module.exports = "/images/arrived.gif";